import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
export const useRevertNotificationSetting = function useRevertNotificationSetting() {
    let { onSuccess } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { mutate, isLoading, error } = useMutationState({
        mutationFn: (args)=>api.notification.revertNotificationSetting(args),
        onSuccess
    });
    return {
        revert: mutate,
        isLoading,
        error
    };
};
